module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"computedWithChildren":"This is an automated KPI. For calculation, please provide data for the following child KPIs:"},"de":{"computedWithChildren":"Dies ist ein automatischer KPI. Zur Berechnung werden Daten aus den folgenden KPIs benötigt:"}}')
  delete Component.options._Ctor
}
